/**
 * @generated SignedSource<<91c0a24fa6ec4775813f4aca3909344c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ChannelMultiSelectorQuery$variables = {
  search?: string | null;
};
export type ChannelMultiSelectorQuery$data = {
  readonly viewer: {
    readonly channels: ReadonlyArray<{
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
    }>;
  };
};
export type ChannelMultiSelectorQuery = {
  response: ChannelMultiSelectorQuery$data;
  variables: ChannelMultiSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "excludePersonal",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": "NAME_ASC"
    },
    {
      "kind": "Variable",
      "name": "search",
      "variableName": "search"
    }
  ],
  "concreteType": "Channel",
  "kind": "LinkedField",
  "name": "channels",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChannelMultiSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChannelMultiSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3db32170f0da7ad3afc75b27ea086de2",
    "id": null,
    "metadata": {},
    "name": "ChannelMultiSelectorQuery",
    "operationKind": "query",
    "text": "query ChannelMultiSelectorQuery(\n  $search: String\n) {\n  viewer {\n    channels(search: $search, excludePersonal: true, orderBy: NAME_ASC) {\n      id\n      name\n      isPrivate\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d8fd0161a85d2e41abfcd5047ff768a";

export default node;
